import { __awaiter, __generator } from "tslib";
import { resolveConfig, } from '@office-start/config-resolver-service';
import { createCacheNetworkRaceOperation, } from '@office-start/persistence-strategies';
import { readFromSimplePersistence, writeToSimplePersistence, } from '@office-start/simple-persistence';
import { getFeatureGates } from './getFeatureGates';
// Key must match embedded config data element id located in HTML
var featureGatesKey = 'featureGates';
var featureGatesPersistenceVersion = 1;
function getFeatureGatesFromClient(options) {
    return __awaiter(this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, resolveConfig(featureGatesKey, options)];
                case 1:
                    config = _a.sent();
                    return [2 /*return*/, config];
            }
        });
    });
}
export function handleExecuteFeatureGatesDataFlow(identity, officeComponentContext) {
    return __awaiter(this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getFeatureGatesFromClient(officeComponentContext)];
                case 1:
                    config = _a.sent();
                    if (!(config === undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getFeatureGates(officeComponentContext.correlationId, function () { return Promise.resolve(identity); }, officeComponentContext.inMockMode, officeComponentContext.officeHomeApiRoot, officeComponentContext.workload, officeComponentContext.getAccessToken, officeComponentContext.jwtAuthEnabled)];
                case 2:
                    config = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, config];
            }
        });
    });
}
export function executeFeatureGatesDataFlow(identity, officeComponentContext) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, createCacheNetworkRaceOperation(function () {
                    return handleExecuteFeatureGatesDataFlow(identity, officeComponentContext);
                }, function () {
                    return readFromSimplePersistence({
                        userId: identity.puid,
                        collectionName: featureGatesKey,
                        collectionVersion: featureGatesPersistenceVersion,
                        key: featureGatesKey,
                    });
                }, function (networkResult) {
                    return writeToSimplePersistence({
                        userId: identity.puid,
                        collectionName: featureGatesKey,
                        collectionVersion: featureGatesPersistenceVersion,
                        key: featureGatesKey,
                        // Passing null tells writeToSimplePersistence to skip writing to IndexDB.
                        // networkResult returning {} indicates an API issue and should not be saved to cache.
                        data: Object.keys(networkResult).length === 0
                            ? null
                            : networkResult,
                    });
                })];
        });
    });
}
//# sourceMappingURL=executeFeatureGatesDataFlow.js.map